import { render, staticRenderFns } from "./guide.vue?vue&type=template&id=19f040d4&scoped=true&"
import script from "./guide.vue?vue&type=script&lang=js&"
export * from "./guide.vue?vue&type=script&lang=js&"
import style0 from "./guide.vue?vue&type=style&index=0&id=19f040d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f040d4",
  null
  
)

/* custom blocks */
import block0 from "./guide.vue?vue&type=custom&index=0&blockType=comment"
if (typeof block0 === 'function') block0(component)

export default component.exports